// Module
var code = "<button \r\n    :class=\"_modifiers[0] +'__button'\"\r\n    :type=\"vm.type ? vm.type : 'button'\" \r\n    :id=\"vm.id\" \r\n    :name=\"vm.name\" \r\n    :value=\"vm.value\"\r\n    :title=\"vm.label\"\r\n    @click=\"$emit('button-click')\"\r\n>\r\n    {{vm.label}}\r\n</button>";
// Exports
module.exports = code;